import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H2, H1 } from '../../StyledComponents';
import Deploy from '../../../assets/avd/AppManage.svg';
import Lock from '../../../assets/avd/unique.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Remote from '../../../assets/avd/testing.svg';
import { BottomBanner } from '../BottomBanner';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 0rem !important;
  }
`;

const Grid = styled.div`
  margin-top: 3rem;
  @media (min-width: 520px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    margin-top: 3rem;
  }
`;

const GridItem = styled.div`
  justify-self: start;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-left: 0rem;
    justify-items: center;
  }
`;
const GridItemRight = styled.div`
  justify-self: end;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;
const FounderName = styled(H2)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: left;
  }
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #4d3df4;
`;

const SectionLeftImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: end;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    margin-left: 0rem;
    width: 50%;
    justify-self: center;
  }
`;
const SectionRightImage = styled(LazyLoadImage)`
  max-width: 250px;
  width: 80%;
  justify-self: center;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 520px) {
    display: none;
  }
`;
const SectionRightImageMobile = styled(LazyLoadImage)`
  max-width: 50%;
  justify-self: center;
  @media (min-width: 521px) {
    display: none;
  }
`;
const SectionSubHeading = styled(H1)`
  padding-top: 1rem;

  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.26;
  width: 60%;
  letter-spacing: normal;
  text-align: left;
  color: #725cbd;
  @media (max-width: 800px) {
    width: 100%;
  }
`;
const SectionSubHeadingRight = styled(H1)`
  padding-top: 1rem;

  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.26;
  letter-spacing: normal;
  text-align: left;
  color: #725cbd;
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 0;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 80%;
  color: #6a718c;

  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    width: 90%;
  }
`;

const SectionContentSecond = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #6a718c;
  padding-top: 0.5rem;
  text-align: left;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    text-align: center;
    width: 90%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  padding-right: 3rem;
  @media (max-width: 520px) {
    padding-right: 0;
  }
`;
const PageTitle = styled(H1)`
  color: #151a2e;

  line-height: 1.28;
  justify-self: center;
  text-align: center;
  margin-bottom: 2rem;
  padding-right: 15%;
  /* font-weight: 600; */
  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 550px) {
    margin-bottom: 2rem;
  }
  @media (max-width: 520px) {
    font-size: 24px;
    padding-right: 0;
  }
`;

const SectionOuter = styled.div`
  width: 80%;
  margin-left: 15%;
  @media (max-width: 520px) {
    margin-left: 10%;
  }
`;
export default () => (
  <div>
    <SectionOuter>
      <Section>
        <PageTitle>Features</PageTitle>
        <Grid>
          <ImgWrapper>
            <SectionLeftImage src={Deploy} alt="auto deploy" />
          </ImgWrapper>
          <GridItem>
            <SectionSubHeading>
              Support for Application and Device Management
            </SectionSubHeading>
            <SectionContent>
              Deploy applications to emulators from the cloud emulating
              application deployment on virtual devices.
            </SectionContent>
          </GridItem>
        </Grid>
        <Grid>
          <GridItemRight>
            <SectionRightImageMobile src={Lock} alt="lock" />
            <SectionSubHeadingRight>
              Unique ID for devices
            </SectionSubHeadingRight>
            <SectionContentSecond>
              Track application performance and test using unique device ID
              associated with every virtual device. This helps in tracking every
              device behaviour easily.
            </SectionContentSecond>
          </GridItemRight>
          <ImgWrapper>
            <SectionRightImage src={Lock} alt="lock device" />
          </ImgWrapper>
        </Grid>
        <Grid>
          <ImgWrapper>
            <SectionLeftImage src={Remote} alt="remote" />
          </ImgWrapper>
          <GridItem>
            <SectionSubHeading>
              Support for testing peripherals
            </SectionSubHeading>
            <SectionContent>
              Emulate peripherals such as printers, card readers and barcode
              scanners.
            </SectionContent>
          </GridItem>
        </Grid>
      </Section>
    </SectionOuter>
    <BottomBanner
      description={`Run your own Virtual Device Lab and stress test application instances on Esper`}
      buttonText={`Take Me To Virtual Device Lab`}
      link="https://esper.io/signup"
    />
  </div>
);
